import { render, staticRenderFns } from "./PostReviewModal.vue?vue&type=template&id=60968da0"
import script from "./PostReviewModal.vue?vue&type=script&lang=js"
export * from "./PostReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports